"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseS3Uri = parseS3Uri;
exports.isS3KeyWithinPrefix = isS3KeyWithinPrefix;
const S3_URI_PREFIX = "s3://";
const MAX_S3_URI_LENGTH = 2048;
function parseS3Uri(value) {
    if (!value.startsWith(S3_URI_PREFIX) || value.length > MAX_S3_URI_LENGTH) {
        return null;
    }
    const withoutScheme = value.slice(S3_URI_PREFIX.length);
    const separatorIndex = withoutScheme.indexOf("/");
    if (separatorIndex <= 0 || separatorIndex === withoutScheme.length - 1) {
        return null;
    }
    const bucket = withoutScheme.slice(0, separatorIndex);
    const key = withoutScheme.slice(separatorIndex + 1);
    if (!bucket ||
        !key ||
        key.startsWith("/") ||
        value.includes("?") ||
        value.includes("#")) {
        return null;
    }
    return { bucket, key };
}
function isS3KeyWithinPrefix(key, prefix) {
    if (!prefix)
        return false;
    const directoryPrefix = prefix.endsWith("/") ? prefix : `${prefix}/`;
    return key.startsWith(directoryPrefix);
}
